// React
import { useState, useEffect } from "react";

// Styled Components
import styled from "styled-components";

// Material UI
// import Button from "@mui/material/Button";
// import ButtonGroup from "@mui/material/ButtonGroup";
import { Button, ButtonGroup } from "@material-ui/core";

// Ethers
// import { ethers } from "ethers";

// Web3Modal
// import Web3Modal from "web3modal";

// Contract
// import SmartContract from "../../../../artifacts/contracts/SmartContract.sol/shoeuziverse.json";

// const SmartContractAddress = "0x62a39bde95da28bead0a70429f040051a2bc3564";

// Candy Machine
import Countdown from "react-countdown";

import { Snackbar } from "@material-ui/core";
import Alert from "@material-ui/lab/Alert";

import * as anchor from "@project-serum/anchor";

import { LAMPORTS_PER_SOL } from "@solana/web3.js";

import { useAnchorWallet } from "@solana/wallet-adapter-react";
import { WalletDialogButton } from "@solana/wallet-adapter-material-ui";

import {
  CandyMachine,
  awaitTransactionSignatureConfirmation,
  getCandyMachineState,
  mintOneToken,
  shortenAddress,
} from "../../../../candy-machine";

const ConnectButton = styled(WalletDialogButton)`
  border-radius: 0 !important;
  font-size: 1.5rem !important;
  height: 58px !important;
  background-color: black !important;
`;

const CounterText = styled.span``;

interface AlertState {
  open: boolean;
  message: string;
  severity: "success" | "info" | "warning" | "error" | undefined;
}

export interface IntroMintProps {
  candyMachineId: anchor.web3.PublicKey;
  config: anchor.web3.PublicKey;
  connection: anchor.web3.Connection;
  startDate: number;
  treasury: anchor.web3.PublicKey;
  txTimeout: number;
}

// const WLH = ["d010febbc18724ad6242524466dafc839b4a0190f663e90ef01f34722b678f27","e49dd5a5461ed951f8ac3d4950b6287f38e696caeff9566a53d9c8d5554509b0","6c03fae2a11c9ef2a17fd8b7cf16c21665449433802fc2d395fcc78687a7a1c9","ef8d24ff1fb010298a3b95bf09776d47d7dc6c558a654ae337d0bf5cf621bcfc","037f633af59a534ee5323d31988a81a0fda8548725644d4c99d47b70704715ac","507e53fc56651ca236651c8d714e606e1a6514707af8da4f8928ffc154259e95","507e53fc56651ca236651c8d714e606e1a6514707af8da4f8928ffc154259e95","216b267c6bedb8e8da4158252673bdab28f0f05a2f89f7f84beb95323b5582c4","507e53fc56651ca236651c8d714e606e1a6514707af8da4f8928ffc154259e95","9cb9aa044bbb7b1d239749dc8371acc88db53b487e85034e3858dd5095a93d8e","f08615f8c865223ec6a0685e17062c1dce6e89a976c50c0c4907485148bfa4e7","0b678a20479d6841621881d7fcb7496793cf805b122f971daf5913f7575e295e","1b0827bb787f440bfabc6bb50f7747a9bf8021e4033f5633f86a63bd11935e71","037f633af59a534ee5323d31988a81a0fda8548725644d4c99d47b70704715ac","fdcd9bf03e97edc3ba5c47148dd1f28e45703c07c3852cda159704b8a8b7d2c6","216b267c6bedb8e8da4158252673bdab28f0f05a2f89f7f84beb95323b5582c4","32f27cdae87ab0692830c28d5536388d917ca9f88b35c529837438c9770ea202","7ebd3b4b57b84323dae04f72ae7cc5b42f633dff3e5150a4b3f86b6c90db3496","ae12b930106d4ddfecf1adcd9de2ff5af4ff173ef187deee826b989d99489662","9cb9aa044bbb7b1d239749dc8371acc88db53b487e85034e3858dd5095a93d8e","ae44e6640ed91cb70b24a091d67dd5a0179eb8c7b1638caed4a6ed539310f7ba","081bf7164fca6ee56055a6e587c587eee204aeec8fb1301fa524a0600f8912df","e303a70b1d13749e0e60fcf67e91b1100269859b5f694d4a04e72cd497c7acf4","e7963e3ac981d73e8341eb4808dd56dbcb30935f74b6af7c1e2066772a105276","34382b32b67d69026fb622f796447fda35267802e8c042e24a99ff4b0418e8dc","4f540d00265710317bc9314013573ec51e0109d72910688c8cda9cf29212add7","b57fc4f434149e47e012856c63a397edfef8f1908ea5dd812cd7cd402e1280c6","aaf1295732562fe78c8302fbe97aa6f9f59f141567217f4dbb70afdfd7928f3d","3eb699573f2c0dfe99751ef60242b8e3bf69bef608af43bd6c6328aa3ef10270","c2ac167ddde9d3bd37790458ae1394d48a429810d2bab92dbafba2d4cc9d3b9a","c2ac167ddde9d3bd37790458ae1394d48a429810d2bab92dbafba2d4cc9d3b9a","84b43d23d52372d599e14beb99ea0e1972af396ec3659f7c9a237c974ed68d57","b492657240db8dde67edde6b2417572e1376de497e19901bd537e7859383a54e","15e657b00dbf2c3d8734f50600d0ea2c1b3b3552a6126a5497e1a958f3adc4e1","589fc1283fdadb407f8a07784f6e769ad8ad7dd373890d6d0e239d8b41183f34","2a18aa308c8cb0b37f4f768ec5b9eb9516be0e98aa67df5f0dbc1e653e0774e2","569a7d91fad206d63c0e532852e7aef150e7eb6ba836252b31e992723546b26e","f543e1924c20f85d752307d921d2666959dae09081eb839efc88a7a1e0e5ce13","8c3d782436a1e3f64f9ec9bbd70dad982dfdf1a97c4c93b321723f47e6185116","48371786ffcffcfa1378f3bdfb33a5e65650a07a68f7f3ff269439fc187ecc97","5cf98576dbb2e239524af407bc97c41d982116fb0249b3066c0ad6ef90d82acb","091bf5dfc0f538609865e68f2ac6489cba57b496e55d00a3bbc8d833d69b9ba4","d3bc091d57d6a3c92bbd3fdb94cb25207ac0236d913c6e76870a212170e1f046","0843568490ed2c0ba07814a8847c25adb5bd371c046d12b100088893c07b50ee","8d6e0e54e4c2ba64dc62601f9733a65cd766dfa18a584f9faed4b76aa0b18311","60eb19668787f876a6d48a37ccd43646a7f0d23def6fa9e498d1b1b412ef73ce","b57fc4f434149e47e012856c63a397edfef8f1908ea5dd812cd7cd402e1280c6","03cff2aab63b72621b2a2d6c98a85890a53471aad7167844be98adc27edb1a9e","5ed46d7725b488f81b31a4b12c98b411040d681511121eb73d11ad53a3bd204f","7f20f8987164cd083ff94d874ca22eab0c6e75226a92544aecc688b1c5e22857","00ef3c0a3f4452f264de02d6f5769720350ecb4373ad949c24d5456055cfea63","aaf1295732562fe78c8302fbe97aa6f9f59f141567217f4dbb70afdfd7928f3d","4172ec95efc1d14cb95947ac2080653c60dc1f33729c68281b51e55ecb756ea6","b229de678c2ff593469308cf52b5857a7a197469bd6c72b7a359fced92c615c2","16e81a03e0ac1c12d61fa0bdd042c381094fd0ae340d74688647290eba4784ca","60686955d97ba45303a286fdc0f6ee0a0bb3c318bfc2e9bea4085d6b95e012f8","c95e0ad74f065802ca439cc9faa6a1de3b67b5feb6b027226993d28455efc6b1","0bf750c180511fd62fabdf8fc11a71cc7057c052935a793aa7e3eee668227ff7","83e7be7289b02ecd7ddad6ce40b531cc76d9d3aeeafdd1dabbcf5ab965a55965","f3fcb281016338337e15a7fecbe12ab13c5bf93626c20526b1d19200818f9be5","64a313249065388b9fec91510ea987c7f59d770c468fdd71a59529e15c28874f","e54ce75d12c726ee1248ab5f843aacd49277c4642e370982e0ea4660a6f38bf8","7f514bc93798ea9bc163bcb78cee89b55d025ad1daf95c7aed68f3debcd0eb8e","bfedb63f7a2fadab0ed43849230d074d01a3bdc174f7a0ca6ac55e0dc6268f33","21d176502d285248e3bf82d4a7ffd125db5318b8eee112c991351e9bf02c9192","b01baa6d479b2aca60497f67f41d7a96f3e34d1c6a972082c79798098c516028","4a89ab02c4373af13a3b3343e8e7e46278a5b4b26495309a71aaef35e83e1816","5708bac4c49fe1e28bfbb161330f466e9e0f3438c629c11a61a69c2e0ec3a851","f46d1f7e0853b73d3001385f868517be3f85a022d0463670a9706984e9c57e4d","c1ee6d4e2385c79407ab2213f4365ddedf3f93bca088a4d1eebc921a89513974","16553655ea52867ae44fe1866d355dca3d9f5f4a2dd338c6bd0339f4d58e8b5b","0ed08969537c56ea63d682aa5d619dc42f69d3a22d3e3bf00c81fae37532b3a4","6fa67851fe03ce7abe7bc23103fe0a94a7abd523ec5482e05350b62257c163b3","081bf7164fca6ee56055a6e587c587eee204aeec8fb1301fa524a0600f8912df","604b7fdc52192d2579b3ca9453e7965661a16fcec051e843ca1f441f66909e81","4908fe336ef61cf8986db1cf84bc1f31e25d8a046c8d58f8bd8ebfea3d4e3e93","2b9d029962d2c56f93d4ee414d72906822747cb2845a121ec3ee9e81b8c16775","722d22c4c9723ea515c66879a96c4e46d324e7d0ed0be1b47d812af2d924c521","a512c9007e9c9bde435b3c2181878c0b9af415b33852f46f87f5d4782c85c917","6e6bc8f445217f753de02cc1316eb4c57324b7a5e0dcde6186ab920952f6ec8c","76e7b555c77d1cfb5f5574eb6f5d837a2ab1513c2184daf336f6a4f9566f42e9","b6b04af17d53d3fb280375685c080d3f405e4af28f1c59cde3bd8c661671eb62","995b27c0cfbbfd73257979661597f7a4c0a4f672a2d799dd3eacddb8c70cb19a","60686955d97ba45303a286fdc0f6ee0a0bb3c318bfc2e9bea4085d6b95e012f8","73b8e9da93f31c5f17da8dda1d24f2a92efef5843ad0137e9f50a8fafdd4857e","5d07fea67e0758589f67233c1f9185278957f9abb82e46abc6fde8e1693d31d8","34382b32b67d69026fb622f796447fda35267802e8c042e24a99ff4b0418e8dc","f3ffd8a28a9ec100502c496b25f5cd6d1d98fdf3be017d1f6a753cd2d3d6c629","17a22bd56bcc65a5d9677d6bfb035acb68178cf1d9fab13c9e77c3f0fe7360d8","69dbdf5a4de5e4ce67978beb3d22ff7e8fe1508852806795b12bb1a5a4b4ea0c","a49e60357d9735c0266265710019cd1b39b1307f16797e44912c15224adfa9aa","386a4093e901bda4dab3f66ee9544ca915bf29d2b541e479c8dac9a82df2e4e3","e8aaa8adc907465bd06cd7a076111696dbcc914d7aa5dbec6f21474b04a1a45b","d8e8312c2a66b860140052d611a672396a06901a5441b61c4930b6157d6bacb3","3eb699573f2c0dfe99751ef60242b8e3bf69bef608af43bd6c6328aa3ef10270","48cbd4d795ca65de1ff4a7e703ac81591a177a881b73f2e850770c9fdfcb1381","7bb90a3183232fdc3e54e52401bb5571168583660b1ce35bd1fdc0f2ef5d70e7","d745850013445424527d199bbf4c193e946d0c14c12ee3065e58c54d0a49876a","9d8dd7eb33a3fa8e38dd8dd017c73802efbb3e695f182a7c01400a206055dff3","604b7fdc52192d2579b3ca9453e7965661a16fcec051e843ca1f441f66909e81","60b2733e485d9b87b8da649dff34cd6b6bec94fa260078ec1c09fe2657d74307","9c0cf3095f5b6558d75cbe7140e696266b07c2724d6f29a8c54d12b7f7040187","5708bac4c49fe1e28bfbb161330f466e9e0f3438c629c11a61a69c2e0ec3a851","5cf98576dbb2e239524af407bc97c41d982116fb0249b3066c0ad6ef90d82acb","5cb289b4defa906e9590996c3f73e303b31c7dcfea9618d87df575cd033fec21","e331b669b889eb94a8e2aa37f6ed125c09fe535e8389dca108b0e9481ad7a4a2","c276817c50b4912ac306a215653ecd99872f5b1319a3e1f11d629731328d8d86","e3a56960762399a6cc6bd34a28366f31fec4679f3a1c71f8c59b7118fa5b9471","4884c526bc900a2e1ef3d582b752bb4eb53b4d7505c82a4398d706d6fb7b56c5","006aed834944396a7218967ce9e232133f18a42848accf472ab75a7c99dc796a","732c7e4fc9b9063638aeed2fa786b5b2e6acb1ac752875474b8b07b922fcc223","7cac9727e8dffd8ea75d870c728cc2563374031b834b6b81f489398858d1bb04","8785bdf0ca5508a3ba8a711dc068acb6533f4e6ac7564b97064c3faf3ceb155c","2a2755153bb8f1103dd591b094d3025c6ebdd695d55165fc08eb1f870d4e8c29","2ddfe1fc2b1cb1bcbb3c3325cb8bf2bc6b654472a68842141a60aa71c82b9d91","ad877eff15bb0c5dbdfae8708a4790d48e17475f74e98b4914cacaa1b2ea43f4","5032743ec121c1ce6d1a7336d22f55e8204875537b10aac8791814a30385fe69","d97b9a054ced2e5f09c0495276845fab59d7d99657646723bbe538eff207a708","294240b3982fbd90c28aeee9357fc1cef468f11e11770e1fedfcc19e1018f5c2","ae44e6640ed91cb70b24a091d67dd5a0179eb8c7b1638caed4a6ed539310f7ba","2453e4bdd2b1c2d52a5a534e9c451454ace46b69db968c4bb2c27d74b0e95b77","5665ef03ea77397f8c06fa8aa0d5c978746c8d2bfc01105773ac248d078f1366","e98142226e54b6c15c9b7f9b2c1804bf0612f3d8e0044dbbe4188d035f92529b","6997536d28b9875826c445222c334249e1bb0df54505b2fe53f5d4f98e3d6990","2e6d21d9b5e838b4711765e50aeec526565d11c3b6f0a773c65653aeddcf4ad3","0b678a20479d6841621881d7fcb7496793cf805b122f971daf5913f7575e295e","6997536d28b9875826c445222c334249e1bb0df54505b2fe53f5d4f98e3d6990","2e7df62e1db2d9b43398a105cf85a2a37a81f89f2d6024f01228403365348522","04761c5b8b0b249df37bea6c46143c13d4d3b5401855a911f7870818083cf7dd","6fc93e25d0469f8095773658cd0387721ee8300b9dfbb6407f57d28e70a1c154","0b678a20479d6841621881d7fcb7496793cf805b122f971daf5913f7575e295e","afd69d0c8c503d26c5b7ca8d3d579a249839ea38df70fedd4318d92adfe9c438","529d1aebf70798b56e311c413c62a2769113c29c4b2c24c797978ef7e334e2ef","6997536d28b9875826c445222c334249e1bb0df54505b2fe53f5d4f98e3d6990","e8ccc2be3981bba59daf68cd0a05ae1002dfa41eb6bf96ed1e294a48712264df","f2891a032003f2e222b66a2e122ec3e3226a3ff17f912fbf8586df823ff0f125"];

// const eath = async (a: string) => {
//   const b = new TextEncoder().encode(a);
//   const c = await crypto.subtle.digest("SHA-256", b);
//   const d = new Uint8Array(c);
//   const e = Array.from(d).map((x) => x.toString(16).padStart(2, "0")).join("");
//   return e;
// };

// const cah = async (a: string) => {
//   const b = await eath(a);
//   console.log(a, b, WLH.includes(b));
//   return WLH.includes(b);
// };

const IntroMint = (props: IntroMintProps) => {
  const [balance, setBalance] = useState<number>();
  const [isActive, setIsActive] = useState(false); // true when countdown completes
  const [isSoldOut, setIsSoldOut] = useState(false); // true when items remaining is zero
  const [isMinting, setIsMinting] = useState(false); // true when user got to press MINT

  const [itemsAvailable, setItemsAvailable] = useState(0);
  const [itemsRedeemed, setItemsRedeemed] = useState(0);
  const [itemsRemaining, setItemsRemaining] = useState(0);

  const [alertState, setAlertState] = useState<AlertState>({
    open: false,
    message: "",
    severity: undefined,
  });

  const [startDate, setStartDate] = useState(new Date(props.startDate));

  const wallet = useAnchorWallet();
  const [candyMachine, setCandyMachine] = useState<CandyMachine>();

  const refreshCandyMachineState = () => {
    (async () => {
      if (!wallet) return;

      const {
        candyMachine,
        goLiveDate,
        itemsAvailable,
        itemsRemaining,
        itemsRedeemed,
      } = await getCandyMachineState(
        wallet as anchor.Wallet,
        props.candyMachineId,
        props.connection
      );

      setItemsAvailable(itemsAvailable);
      setItemsRemaining(itemsRemaining);
      setItemsRedeemed(itemsRedeemed);

      setIsSoldOut(itemsRemaining === 0);
      setStartDate(goLiveDate);
      setCandyMachine(candyMachine);
    })();
  };

  const onMint = async () => {
    try {
      setIsMinting(true);

      if (wallet && candyMachine?.program) {
        // const v = await cah(wallet.publicKey.toBase58());

        // if (!v)
        //   return;

        // setIsMinting(true);

        for (let minted = 0; minted < amountToMint; minted++) {
          const mintTxId = await mintOneToken(
            candyMachine,
            props.config,
            wallet.publicKey,
            props.treasury
          );

          const status = await awaitTransactionSignatureConfirmation(
            mintTxId,
            props.txTimeout,
            props.connection,
            "singleGossip",
            false
          );

          if (!status?.err) {
            setAlertState({
              open: true,
              message: "Congratulations! Mint succeeded!",
              severity: "success",
            });
          } else {
            setAlertState({
              open: true,
              message: "Mint failed! Please try again!",
              severity: "error",
            });
          }
        }
      }
    } catch (error : any) {
      // TODO: blech:
      let message = error.msg || "Minting failed! Please try again!";
      if (!error.msg) {
        if (error.message.indexOf("0x138")) {
        } else if (error.message.indexOf("0x137")) {
          message = `SOLD OUT!`;
        } else if (error.message.indexOf("0x135")) {
          message = `Insufficient funds to mint. Please fund your wallet.`;
        }
      } else {
        if (error.code === 311) {
          message = `SOLD OUT!`;
          setIsSoldOut(true);
        } else if (error.code === 312) {
          message = `Minting period hasn't started yet.`;
        }
      }

      setAlertState({
        open: true,
        message,
        severity: "error",
      });
    } finally {
      if (wallet) {
        const balance = await props.connection.getBalance(wallet.publicKey);
        setBalance(balance / LAMPORTS_PER_SOL);
      }
      setIsMinting(false);
      refreshCandyMachineState();
    }
  };

  useEffect(() => {
    (async () => {
      if (wallet) {
        const balance = await props.connection.getBalance(wallet.publicKey);
        setBalance(balance / LAMPORTS_PER_SOL);
      }
    })();
  }, [wallet, props.connection]);

  useEffect(refreshCandyMachineState, [
    wallet,
    props.candyMachineId,
    props.connection,
  ]);

  useEffect(() => {
    if (wallet && amountToMint > itemsRemaining) {
      setAmountToMint(_ => itemsRemaining);
    }
  }, [wallet, itemsRemaining]);

  const [amountToMint, setAmountToMint] = useState(1);

  const decreaseQuantity = () => {
    if (amountToMint > 1) {
      setAmountToMint((prev) => prev - 1);
    }
  };

  const increaseQuantity = () => {
    if (wallet && amountToMint >= itemsRemaining)
      return;

    if (amountToMint < 10) {
      setAmountToMint((prev) => prev + 1);
    }
  };

  return (
    <Wrapper>
      <ButtonGroup size="small" className="amount-wrapper">
        <Button className="decrease" onClick={decreaseQuantity}>
          -
        </Button>

        <Button className="quantity" disabled>
          {amountToMint}
        </Button>

        <Button className="increase" onClick={increaseQuantity}>
          +
        </Button>
      </ButtonGroup>

      {wallet ? (
        <Button
          variant="contained"
          className="button"
          disabled={isSoldOut || isMinting || !isActive}
          onClick={onMint}
        >
          {isSoldOut ? (
            'SOLD OUT'
          ) : (
            isActive ? (
              isMinting ? (
                'PLEASE WAIT...'
              ) : (
                'MINT'
              )
            ) : (
              <Countdown
                date={startDate}
                onMount={({ completed }) => setIsActive(completed)}
                onComplete={() => setIsActive(true)}
                renderer={renderCounter}
              />
            )
          )}
        </Button>
      ) : (
        <ConnectButton>
          CONNECT WALLET
        </ConnectButton>
      )}

      <div className="flex flex-col gap-2 text-sm text-center">
        <span>
          <b>Mint cost:</b> 0.4 SOL each
        </span>

        {wallet && (
          <>
            <span>
              {itemsAvailable - itemsRemaining} / {itemsAvailable} minted
            </span>
            <span>
              <b>Address:</b> {shortenAddress(wallet.publicKey.toBase58())}
            </span>
            <span>
              <b>Balance:</b> {(balance || 0).toLocaleString()} SOL
            </span>
          </>
        )}
      </div>

      <Snackbar
        open={alertState.open}
        autoHideDuration={6000}
        onClose={() => setAlertState({ ...alertState, open: false })}
      >
        <Alert
          onClose={() => setAlertState({ ...alertState, open: false })}
          severity={alertState.severity}
        >
          {alertState.message}
        </Alert>
      </Snackbar>
    </Wrapper>
  );
};

const renderCounter = ({ days, hours, minutes, seconds, completed }: any) => {
  return (
    <CounterText>
      {hours + (days || 0) * 24} hours, {minutes} minutes, {seconds} seconds
    </CounterText>
  );
};

export default IntroMint;

const Wrapper = styled.div`
  display: flex;
  flex-direction: column;
  gap: 20px;
  padding-top: 50px;

  .amount-wrapper {
    width: 300px;
    background-color: #000;
    border-radius: 0;

    .increase {
      font-size: 30px;
      width: 101px;
      color: #fff;
      border: none;
      outline: none;
    }
    .decrease {
      font-size: 30px;
      width: 101px;
      color: #fff;
      border: none;
      outline: none;
    }
    .quantity {
      font-size: 30px;
      color: #fff;
      width: 101px;
      border: none;
    }
  }

  .button {
    border-radius: 0;
    background-color: #000;
    width: 300px;
    padding: 15px;

    font-family: "interstate", sans-serif;
    font-weight: 700;
    font-style: normal;

    font-size: 1.4rem;

    color: white;

    &:hover {
      background-color: #000;
    }
  }
`;
